
define('ldsh!modules/editor/templates/elements_tree', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<h4 class="ed-layers-tree-title" data-i18n="editor.sidebar.elementsTree"></h4>\n<div class="ed-tree-list js-tree-children"></div>\n';

}
return __p
};});

